export const INSTDBBUNDLE = {
  INST: {
    EN: 'Institution',
    FR: 'Institution',
    ES: 'Institución',
    AR: 'Institution',
    RU: 'Institution',
    ZH: 'Institution'
  },
  INSTS: {
    EN: 'Institutions',
    FR: 'Institutions',
    ES: 'Instituciones',
    AR: 'Institutions',
    RU: 'Institutions',
    ZH: 'Institutions'
  },
  CNTRY: {
    EN: 'Country',
    FR: 'Pays',
    ES: 'País',
    AR: 'Country',
    RU: 'Country',
    ZH: 'Country'
  },
  TYP: {
    EN: 'Type',
    FR: 'Type',
    ES: 'Tipo',
    AR: 'Type',
    RU: 'Type',
    ZH: 'Type'
  },
  ACTIVE: {
    EN: 'Active',
    FR: 'Actif ',
    ES: 'Activo ',
    AR: 'Active',
    RU: 'Active',
    ZH: 'Active'
  },
  YES: {
    EN: 'Yes',
    FR: 'Oui ',
    ES: 'Sí',
    AR: 'Yes',
    RU: 'Yes',
    ZH: 'Yes'
  },
  NO: {
    EN: 'No',
    FR: 'Non ',
    ES: 'No',
    AR: 'No',
    RU: 'No',
    ZH: 'No'
  },
  SCTR: {
    EN: 'Sector',
    FR: 'Secteur ',
    ES: 'Sector',
    AR: 'Sector',
    RU: 'Sector',
    ZH: 'Sector'
  },
  ACTIVITY: {
    EN: 'Activity',
    FR: 'Activité',
    ES: 'Actividad',
    AR: 'Activity',
    RU: 'Activity',
    ZH: 'Activity'
  },
  FILTERBYINST: {
    EN: 'Filter by Institution',
    FR: 'Filtrer par Institution',
    ES: 'Filtrar por Institución',
    AR: 'Filter by Institution',
    RU: 'Filter by Institution',
    ZH: 'Filter by Institution'
  },
  FILTERBYCNT: {
    EN: 'Filter by Country',
    FR: 'Filtrer par Pays',
    ES: 'Filtrar por País',
    AR: 'Filter by Country',
    RU: 'Filter by Country',
    ZH: 'Filter by Country'
  },
  FILTERBYTYP: {
    EN: 'Filter by Type',
    FR: 'Filtrer par Type',
    ES: 'Filtrar por Tipo',
    AR: 'Filter by Type',
    RU: 'Filter by Type',
    ZH: 'Filter by Type'
  },
  FILTERBYSCTR: {
    EN: 'Filter by Sector',
    FR: 'Filtrer par Secteur',
    ES: 'Filtrar por Sector',
    AR: 'Filter by Sector',
    RU: 'Filter by Sector',
    ZH: 'Filter by Sector'
  },
  FILTERBYACTIVITY: {
    EN: 'Filter by Activity',
    FR: 'Filtrer par Activité',
    ES: 'Filtrar por Actividad',
    AR: 'Filter by Activity',
    RU: 'Filter by Activity',
    ZH: 'Filter by Activity'
  },
  SRCHINST: {
    EN: 'search an institution',
    FR: 'rechercher une institution',
    ES: 'buscar una institución',
    AR: 'search an institution',
    RU: 'search an institution',
    ZH: 'search an institution'
  },
  SLCTCNTRY: {
    EN: 'select country',
    FR: 'sélectionner le pays',
    ES: 'seleccionar el pais',
    AR: 'select country',
    RU: 'select country',
    ZH: 'select country'
  },
  SLCTTYP: {
    EN: 'select type',
    FR: 'sélectionner le type',
    ES: 'seleccionar el tipo',
    AR: 'select type',
    RU: 'select type',
    ZH: 'select type'
  },
  SLCTSCTR: {
    EN: 'select sector',
    FR: 'sélectionner le secteur',
    ES: 'seleccionar el sector',
    AR: 'select sector',
    RU: 'select sector',
    ZH: 'select sector'
  },
  SLCTACTIVITY: {
    EN: 'select activity',
    FR: 'sélectionner l\'activité',
    ES: 'seleccionar la actividad',
    AR: 'select activity',
    RU: 'select activity',
    ZH: 'select activity'
  },
  NODATA: {
    EN: 'No data found',
    FR: 'Aucune donnée disponible',
    ES: 'Datos no encontrados',
    AR: 'No data found',
    RU: 'No data found',
    ZH: 'No data found'
  },
  LOADINGINST: {
    EN: 'Loading Institutions',
    FR: 'Institutions de chargement',
    ES: 'Instituciones de carga',
    AR: 'Loading Institutions',
    RU: 'Loading Institutions',
    ZH: 'Loading Institutions'
  },
  OF: {
    EN: 'of',
    FR: 'de ',
    ES: 'de',
    AR: 'of',
    RU: 'of',
    ZH: 'of'
  },
  UNDER: {
    EN: 'Under',
    FR: 'Sous ',
    ES: 'Parte de',
    AR: 'Under',
    RU: 'Under',
    ZH: 'Under'
  },
  REPLACEDBY: {
    EN: 'Replaced by',
    FR: 'Remplacé par',
    ES: 'Reemplazado por',
    AR: 'Replaced by',
    RU: 'Replaced by',
    ZH: 'Replaced by'
  },
  ALL: {
    EN: '--- all ---',
    FR: '--- tout --- ',
    ES: '--- todo ---',
    AR: '--- all ---',
    RU: '--- all ---',
    ZH: '--- all ---'
  },
};

export const BUNDLE = {
  COMMON: {
    NODATA: {
      EN: 'No Data Found',
      AR: 'No Data Found',
      ES: 'No Data Found',
      FR: 'No Data Found',
      RU: 'No Data Found',
      ZH: 'No Data Found',
    },
    LOADINGINST: {
      EN: 'Loading Data',
      AR: 'Loading Data',
      ES: 'Loading Data',
      FR: 'Loading Data',
      RU: 'Loading Data',
      ZH: 'Loading Data',
    },
    FETCHERROR: {
      EN: 'Data fetch error',
      AR: 'Data fetch error',
      ES: 'Data fetch error',
      FR: 'Data fetch error',
      RU: 'Data fetch error',
      ZH: 'Data fetch error',
    },
    SITETITLE: {
      EN: 'AQUASTAT - FAO\'s Global Information System on Water and Agriculture',
      AR: 'AQUASTAT - FAO\'s Global Information System on Water and Agriculture',
      ES: 'AQUASTAT - FAO\'s Global Information System on Water and Agriculture',
      FR: 'AQUASTAT - FAO\'s Global Information System on Water and Agriculture',
      RU: 'AQUASTAT - FAO\'s Global Information System on Water and Agriculture',
      ZH: 'AQUASTAT - FAO\'s Global Information System on Water and Agriculture',
    },
  },
  INSTDB: {},
  FAOTERM: {
    TERM: {
      EN: 'Term',
      AR: 'Term',
      ES: 'Term',
      FR: 'Term',
      RU: 'Term',
      ZH: 'Term'
    },
    TERMS: {
      EN: 'Terms',
      AR: 'Terms',
      ES: 'Terms',
      FR: 'Terms',
      RU: 'Terms',
      ZH: 'Terms'
    },
    SEARCHBYTERM: {
      EN: 'search by term...',
      AR: 'search by term...',
      ES: 'search by term...',
      FR: 'search by term...',
      RU: 'search by term...',
      ZH: 'search by term...'
    },
    INFO: {
      EN: 'Use the search box above to get started',
      AR: 'Use the search box above to get started',
      ES: 'Use the search box above to get started',
      FR: 'Use the search box above to get started',
      RU: 'Use the search box above to get started',
      ZH: 'Use the search box above to get started'
    },
    SBJCT: {
      EN: 'Subject',
      AR: 'Subject',
      ES: 'Subject',
      FR: 'Subject',
      RU: 'Subject',
      ZH: 'Subject'
    },
    UNKERR: {
      EN: 'An unknown error has occured, please try again using different search string.',
      AR: 'An unknown error has occured, please try again using different search string.',
      ES: 'An unknown error has occured, please try again using different search string.',
      FR: 'An unknown error has occured, please try again using different search string.',
      RU: 'An unknown error has occured, please try again using different search string.',
      ZH: 'An unknown error has occured, please try again using different search string.'
    },
    DTLTITLE: {
      EN: 'FAO TERM DETAIL',
      AR: 'FAO TERM DETAIL',
      ES: 'FAO TERM DETAIL',
      FR: 'FAO TERM DETAIL',
      RU: 'FAO TERM DETAIL',
      ZH: 'FAO TERM DETAIL'
    },
    DFNTN: {
      EN: 'Definition',
      AR: 'Definition',
      ES: 'Definition',
      FR: 'Definition',
      RU: 'Definition',
      ZH: 'Definition'
    },
    RMRK: {
      EN: 'Remark',
      AR: 'Remark',
      ES: 'Remark',
      FR: 'Remark',
      RU: 'Remark',
      ZH: 'Remark'
    },
    RLTDTRM: {
      EN: 'Related Terms',
      AR: 'Related Terms',
      ES: 'Related Terms',
      FR: 'Related Terms',
      RU: 'Related Terms',
      ZH: 'Related Terms'
    },
    SRC: {
      EN: 'Source',
      AR: 'Source',
      ES: 'Source',
      FR: 'Source',
      RU: 'Source',
      ZH: 'Source'
    },
    TRMSRC: {
      EN: 'Term Source',
      AR: 'Term Source',
      ES: 'Term Source',
      FR: 'Term Source',
      RU: 'Term Source',
      ZH: 'Term Source'
    },
    DFNSRC: {
      EN: 'Definition Source',
      AR: 'Definition Source',
      ES: 'Definition Source',
      FR: 'Definition Source',
      RU: 'Definition Source',
      ZH: 'Definition Source'
    },
    CLS: {
      EN: 'Close',
      AR: 'Close',
      ES: 'Close',
      FR: 'Close',
      RU: 'Close',
      ZH: 'Close'
    },
    GLSRY: {
      EN: 'Glossary',
      AR: 'Glossary',
      ES: 'Glossary',
      FR: 'Glossary',
      RU: 'Glossary',
      ZH: 'Glossary'
    },
    SHRTDSC: {
      EN: 'AQUASTAT maintains a glossary in all six official languages of FAO: Arabic, Chinese, English, French, Russian and Spanish. In addition to detailed definitions of the 180+ variables in the database, the glossary also contains definitions of supplemental 300 terms that are commonly used in this website. The entire database of terms and definitions has been fully integrated into the corporate FAO TERM database and portal where it is grouped in the Water collection, and flagged as “AQUASTAT” series.',
      AR: 'AQUASTAT maintains a glossary in all six official languages of FAO: Arabic, Chinese, English, French, Russian and Spanish. In addition to detailed definitions of the 180+ variables in the database, the glossary also contains definitions of supplemental 300 terms that are commonly used in this website. The entire database of terms and definitions has been fully integrated into the corporate FAO TERM database and portal where it is grouped in the Water collection, and flagged as “AQUASTAT” series.',
      ES: 'AQUASTAT mantiene un glosario en los seis idiomas oficiales de la FAO: árabe, chino, inglés, francés, ruso y español. Además de las definiciones detalladas de más de 180 variables en la base de datos, el glosario también contiene definiciones de los 300 términos complementarios que se usan comúnmente en este sitio web. La base de datos completa de términos y definiciones se ha integrado completamente en la base de datos corporativa de la FAO TERM y en el portal donde se agrupa en la Colección de agua y se marca como serie "AQUASTAT".',
      FR: 'AQUASTAT gère un glossaire dans les six langues officielles de la FAO: anglais, arabe, chinois, espagnol, français et russe. Outre les définitions détaillées de plus de 180 variables de la base de données, le glossaire contient également les définitions de 300 termes supplémentaires couramment utilisés dans ce site web. La base de données complète des termes et définitions a été entièrement intégrée dans la base de données et dans le portail de la FAO TERM où elle est regroupée dans la collection Water, et marquée comme série «AQUASTAT».',
      RU: 'AQUASTAT maintains a glossary in all six official languages of FAO: Arabic, Chinese, English, French, Russian and Spanish. In addition to detailed definitions of the 180+ variables in the database, the glossary also contains definitions of supplemental 300 terms that are commonly used in this website. The entire database of terms and definitions has been fully integrated into the corporate FAO TERM database and portal where it is grouped in the Water collection, and flagged as “AQUASTAT” series.',
      ZH: 'AQUASTAT maintains a glossary in all six official languages of FAO: Arabic, Chinese, English, French, Russian and Spanish. In addition to detailed definitions of the 180+ variables in the database, the glossary also contains definitions of supplemental 300 terms that are commonly used in this website. The entire database of terms and definitions has been fully integrated into the corporate FAO TERM database and portal where it is grouped in the Water collection, and flagged as “AQUASTAT” series.',
    },
    GUIDE: {
      AR: 'The search tool works in the same language as this Web page. A language switch can be found on the top right.',
      EN: 'The search tool works in the same language as this Web page. A language switch can be found on the top right.',
      ES: 'La siguiente herramienta de búsqueda funciona en el mismo idioma que esta página web. Se puede encontrar un cambio de idioma en la esquina superior derecha.',
      FR: 'L\'outil de recherche ci-dessous fonctionne dans la même langue que cette page web. Un commutateur de langue se trouve en haut à droite.',
      RU: 'The search tool works in the same language as this Web page. A language switch can be found on the top right.',
      ZH: 'The search tool works in the same language as this Web page. A language switch can be found on the top right.'
    },
  },
};